import React from 'react'
import AnimationRevealPage from 'helpers/AnimationRevealPage.js'
import { Container, ContentWithPaddingXl } from 'components/misc/Layouts'
import tw from 'twin.macro'
import styled from 'styled-components'
import Header, { PrimaryLink as PrimaryLinkBase, LogoLink } from "../../../components/headers/light.js";
import icon from "../../../images/lra.svg"
import SpecialEdu from "components/cards/Videos.js";

const HeadingRow = tw.div`flex`
const StyledHeader = styled(Header)`
  ${tw`p-0 max-w-none w-full`}
  ${LogoLink} {
    ${tw`text-black hover:border-gray-300 hover:text-gray-300`}
  }
`;

export default ({
  navLinks = [],
  logoLink = (
    <LogoLink href="/home">
      <img src={icon} alt="logo" />
      LightRainAir
    </LogoLink>
  ),
  headingText = "Year 42 Philip Tribe Education for the Sealing of Revelation",
}) => {
  return (
    <>
      <AnimationRevealPage>
        <StyledHeader links={navLinks}  logoLink={logoLink}/>
        <Container>
          <ContentWithPaddingXl>
            <HeadingRow>
            </HeadingRow>
            <SpecialEdu heading={headingText} table='philip_rev_education_videos'/>
          </ContentWithPaddingXl>
        </Container>
      </AnimationRevealPage>
    </>
  )
}